(function() { module.exports = window["wp"]["viewport"]; }());